import { createDependency } from '@agilepoint/restate-core/lib/ioc-container';
import { IAppContext, IConfigurationBase } from '@agilepoint/wat';

export const appContextDependency = createDependency<IAppContext<IConfigurationBase>>(Symbol('AppContext'));
